import React, { useEffect, useState } from 'react';
import propTypes from 'prop-types';
;
import { Button, Columns, Column, MuiTitle } from 'src/ui/mui-ui-kit';;;
import {
  setBreadcrumbs,
  InnerLoader,
  UiToastAdapter,
  ConfirmChangesModal,
} from 'src/ui';
import { toast } from 'react-toastify';
import { getUser } from 'src/user';
import { getToken } from 'src/auth';
import { connect } from 'react-redux';
import { fetchAccount, getAccount } from 'src/account';
import {
  fetchInsurancePeople,
  getInsurancePeople,
  submitInsurancePeople,
} from '../redux';
import { InsuranceTable } from '../components';

const InsuranceSubmitListPage = ({
  user,
  token,
  setBreadcrumbs,
  fetchInsurancePeople,
  submitInsurancePeople,
  people,
}) => {
  const [loading, setLoading] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [initData, setInitData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    (async () => {
      setBreadcrumbs([
        { label: 'Insurance Submit', href: '/insurance-submit' },
      ]);
      if (token.isValid()) {
        await fetchInsurancePeople({
          fiId: user.financialInstitutionId,
        });
        setLoading(false);
      }
    })();
  }, []);
  useEffect(() => {
    // Create a copy of people.people when it changes
    if (people.people) {
      setInitData([...people.people]);
    }
  }, [people.people]);

  const handleRowSelection = (row, action) => {
    if (action === 'add') {
      // Remove the selected row from the initData array
      const updatedData = initData.filter(dataRow => dataRow.id !== row.id);
      setInitData(updatedData);
      // Add the row to the selectedRows array
      setSelectedRows([...selectedRows, row]);
    } else if (action === 'remove') {
      const updatedData = selectedRows.filter(dataRow => dataRow.id !== row.id);
      setInitData([...initData, row]);
      setSelectedRows(updatedData);
    }
  };

  const handleReset = () => {
    setInitData(people.people);
    setSelectedRows([]);
  };

  const handleSubmit = async () => {
    try {
      const insurancePeople = selectedRows.map(person => person.id);
      const result = await submitInsurancePeople({
        fiId: user.financialInstitutionId,
        insurancePeople,
        // insurancePeople: [89],
      });
      setShowModal(false);
      if (result.error) {
        const errorMessage = result.payload.response.detail;
        toast(UiToastAdapter(errorMessage, 'danger'));
      } else {
        toast(
          UiToastAdapter(
            `${selectedRows.reduce(
              (acc, curr) => acc + curr.familySize,
              0
            )} people successfully submitted!`,
            'success'
          )
        );
        handleReset();
      }
    } catch (e) {
      toast(UiToastAdapter('An unexpected error occurred.', 'danger'));
    }
  };

  return (
    <>
      {!loading && !people.isLoading() ? (
        <>
          <div className="transactions-list-page-summary">
            <Columns>
              <Column>
                <MuiTitle isSize="4" hasTextColor="info" tag="h2">
                  Selected
                </MuiTitle>
              </Column>
              <Column style={{ textAlign: 'right' }}>
                <div className="one-column-buttons">
                  <Button
                    hasTextColor="info"
                    disabled={!selectedRows.length}
                    onClick={handleReset}
                  >
                    Reset
                  </Button>
                  <Button
                    isColor="gradient-bright"
                    onClick={() => setShowModal(true)}
                    disabled={
                      selectedRows.reduce(
                        (acc, curr) => acc + curr.familySize,
                        0
                      ) < 5
                    }
                  >
                    Submit
                  </Button>
                </div>
              </Column>
            </Columns>

            <InnerInsuranceSubmitListPage
              data={selectedRows}
              onRowSelection={row => handleRowSelection(row, 'remove')}
              type="submit"
            />
          </div>
          <Columns>
            <Column>
              <MuiTitle isSize="4" hasTextColor="info" tag="h2">
                Users
              </MuiTitle>

              <InnerInsuranceSubmitListPage
                data={initData}
                onRowSelection={row => handleRowSelection(row, 'add')}
                type="add"
              />
            </Column>

            <ConfirmChangesModal
              title="Insurance Submit"
              text={`Would you like to submit information for ${selectedRows.reduce(
                (acc, curr) => acc + curr.familySize,
                0
              )} people?`}
              isActive={showModal}
              onClickCancel={() => setShowModal(false)}
              onClickSubmit={handleSubmit}
            />
          </Columns>
        </>
      ) : (
        <InnerLoader visible />
      )}
    </>
  );
};
const InnerInsuranceSubmitListPage = props => {
  return <InsuranceTable {...props} />;
};
function mapStateToProps(state) {
  return {
    user: getUser(state),
    token: getToken(state),
    account: getAccount(state),
    people: getInsurancePeople(state),
  };
}
InsuranceSubmitListPage.propTypes = {
  user: propTypes.object.isRequired,
  token: propTypes.object.isRequired,
  setBreadcrumbs: propTypes.func.isRequired,
  fetchInsurancePeople: propTypes.func.isRequired,
  submitInsurancePeople: propTypes.func.isRequired,
  people: propTypes.object.isRequired,
};
const connectedInsuranceSubmitListPage = connect(mapStateToProps, {
  setBreadcrumbs,
  fetchInsurancePeople,
  fetchAccount,
  submitInsurancePeople,
})(InsuranceSubmitListPage);

export { connectedInsuranceSubmitListPage as InsuranceSubmitListPage };
